import commonPageService from 'pcCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import { showCustomImage } from 'globalCommon/utils/index';
import { UserLogoMap } from '../common/utils/imageSource';
import './reset.css';
import './style.css';

const init = () => {
    showCustomImage(UserLogoMap, 'show-logo');
    commonPageService({ renderAfter: syncRender });
};

init();
